/* import __COLOCATED_TEMPLATE__ from './materials.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { cached, tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import { restartableTask, timeout } from 'ember-concurrency';
import { TrackedAsyncData } from 'ember-async-data';
import { DateTime } from 'luxon';
import { filterBy, sortBy, uniqueById } from 'ilios-common/utils/array-helpers';
const DEBOUNCE_DELAY = 250;
let DashboardMaterialsComponent = (_class = class DashboardMaterialsComponent extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "daysInAdvance", 60);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "fetch", _descriptor2, this);
    _initializerDefineProperty(this, "iliosConfig", _descriptor3, this);
    _initializerDefineProperty(this, "showAllMaterials", _descriptor4, this);
    _initializerDefineProperty(this, "currentUser", _descriptor5, this);
    _defineProperty(this, "crossesBoundaryConfig", new TrackedAsyncData(this.iliosConfig.itemFromConfig('academicYearCrossesCalendarYearBoundaries')));
    _defineProperty(this, "setQuery", _buildTask(() => ({
      context: this,
      generator: function* (query) {
        yield timeout(DEBOUNCE_DELAY);
        this.args.setOffset(0);
        this.args.setFilter(query);
      }
    }), null, "setQuery", "restartable"));
  }
  get courseData() {
    return new TrackedAsyncData(this.loadCourse(this.args.courseIdFilter));
  }
  get course() {
    return this.courseData.isResolved ? this.courseData.value : null;
  }
  get courseLoaded() {
    return this.courseData.isResolved;
  }
  get materialsData() {
    return new TrackedAsyncData(this.loadMaterials(this.args.showAllMaterials));
  }
  get materials() {
    return this.materialsData.isResolved ? this.materialsData.value : [];
  }
  get materialsLoaded() {
    return this.materialsData.isResolved;
  }
  get academicYearCrossesCalendarYearBoundaries() {
    return this.crossesBoundaryConfig.isResolved ? this.crossesBoundaryConfig.value : null;
  }
  async loadMaterials() {
    const user = await this.currentUser.getModel();
    let url = `${this.iliosConfig.apiNameSpace}/usermaterials/${user.id}`;
    if (!this.args.showAllMaterials) {
      const now = DateTime.now();
      const from = now.set({
        hour: 0,
        minute: 0
      }).toUnixInteger();
      const to = now.set({
        hour: 23,
        minute: 59
      }).plus({
        day: this.daysInAdvance
      }).toUnixInteger();
      url += `?before=${to}&after=${from}`;
    }
    const data = await this.fetch.getJsonFromApiHost(url);
    return data.userMaterials;
  }
  async loadCourse(courseId) {
    let course = null;
    try {
      course = await this.store.findRecord('course', courseId);
    } catch (e) {
      // eat the exception
    }
    return course;
  }
  get canApplyCourseFilter() {
    if (isPresent(this.args.courseIdFilter)) {
      return this.materialsFilteredByCourse.length;
    }
    return true;
  }
  get materialsFilteredByCourse() {
    if (isPresent(this.args.courseIdFilter)) {
      return filterBy(this.materials, 'course', this.args.courseIdFilter);
    }
    return this.materials;
  }
  get allFilteredMaterials() {
    let materials = this.materialsFilteredByCourse;
    if (isPresent(this.args.filter)) {
      materials = materials.filter(({
        courseTitle,
        instructors,
        sessionTitle,
        title
      }) => {
        let searchString = `${title} ${courseTitle} ${sessionTitle} `;
        if (isPresent(instructors)) {
          searchString += instructors.join(' ');
        }
        return searchString.toLowerCase().includes(this.args.filter.toLowerCase());
      });
    }
    const sortedMaterials = sortBy(materials, this.sortInfo.column);
    if (this.sortInfo.descending) {
      return sortedMaterials.reverse();
    }
    return sortedMaterials;
  }
  get sortInfo() {
    const parts = this.args.sortBy.split(':');
    const column = parts[0];
    const descending = parts.length > 1 && parts[1] === 'desc';
    return {
      column,
      descending,
      sortBy: this.args.sortBy
    };
  }
  get filteredMaterials() {
    if (this.args.limit >= this.total) {
      return this.allFilteredMaterials;
    }
    return this.allFilteredMaterials.slice(this.args.offset, this.args.offset + this.args.limit);
  }
  get total() {
    return this.allFilteredMaterials.length;
  }
  get courses() {
    if (!this.materials) {
      return [];
    }
    const arr = this.materials.map(material => {
      return {
        id: material.course,
        title: material.courseTitle,
        externalId: material.courseExternalId,
        year: material.courseYear
      };
    });
    return sortBy(uniqueById(arr), ['year', 'title']);
  }
  get sortedAscending() {
    return this.args.sortBy.search(/desc/) === -1;
  }
  sortBy(what) {
    if (this.args.sortBy === what) {
      what += ':desc';
    }
    this.args.setSortBy(what);
  }
  changeCourseIdFilter(event) {
    this.args.setOffset(0);
    this.args.setCourseIdFilter(event.target.value);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "fetch", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "iliosConfig", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "showAllMaterials", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "courseData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "courseData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "materialsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "materialsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "academicYearCrossesCalendarYearBoundaries", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "academicYearCrossesCalendarYearBoundaries"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sortBy", [action], Object.getOwnPropertyDescriptor(_class.prototype, "sortBy"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "changeCourseIdFilter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "changeCourseIdFilter"), _class.prototype), _class);
export { DashboardMaterialsComponent as default };